import { IMAGES } from "@/lib/site";

export default function Opportunity() {
    return (
        <section
            id="opportunity"
            data-testid="opportunity-section"
            className="py-24 md:py-32 lg:py-40 bg-bone2 relative overflow-hidden"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12 items-start">
                    <div className="col-span-12 lg:col-span-5">
                        <span className="number-mark text-ink2">§ 07</span>
                        <h2
                            data-testid="opportunity-heading"
                            className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-ink"
                        >
                            The
                            <br />
                            opportunity.
                        </h2>

                        <div className="mt-10 overflow-hidden border border-rule">
                            <img
                                src={IMAGES.coast}
                                alt="Rugged Australian coastline"
                                data-testid="opportunity-image"
                                className="w-full h-[280px] md:h-[420px] object-cover"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    <div className="col-span-12 lg:col-span-7 lg:pl-12 lg:pt-16">
                        <blockquote
                            data-testid="opportunity-pullquote"
                            className="font-serif text-3xl md:text-4xl lg:text-[44px] leading-[1.15] text-ink"
                        >
                            <span className="text-ochre">“</span>Australia is
                            entering a new era of restoration, nature repair
                            and climate adaptation. Without Indigenous
                            governance and fair economic participation, new
                            environmental markets could repeat old patterns of
                            extraction.<span className="text-ochre">”</span>
                        </blockquote>

                        <div className="mt-10 space-y-6 text-ink2 text-lg leading-relaxed max-w-2xl">
                            <p>
                                Caring for Country helps build a different
                                pathway. One where Indigenous people are not
                                simply consulted, employed or included after
                                decisions are made.
                            </p>
                            <p className="text-ink">
                                One where they are leading, designing,
                                governing and benefiting from the future of
                                land, sea, water and restoration work.
                            </p>
                        </div>

                        <div
                            data-testid="framework-keystones"
                            className="mt-14 border-t border-rule pt-10"
                        >
                            <p className="font-serif italic text-2xl md:text-3xl text-ink leading-[1.2] max-w-xl">
                                Community authority.
                                <br />
                                Shared stewardship.
                                <br />
                                Healthy Country.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
